import v2Axios from "../v2Axios";
import { CONFIG } from "../../config";
export const fetchDocumentsService = async (serialNumber) => {
	try {
		const response = await v2Axios.get(
			`${CONFIG.COURSEURL}/api/v2/documents/` + serialNumber
		);
		if (response.status === 200) {
			return (
				response.data?.documentContent ??
				response.data?.documents?.documentContent ??
				"Some error occured while processing your document"
			);
		} else {
			return "Some error occured while processing your document";
		}
	} catch (error) {
		console.error("Error fetching document content:", error);
		return "Some error occured while processing your document";
	}
};
